<template>
  <div class="soul-index">
    <div>
      <div class="list">
        <div class="left">
          <div class="left-img">
            <img :src="list.titleUrl" alt="" />
          </div>
        </div>
        <div class="right">
          <div class="right-item">
            <div class="top">{{ list.title }}</div>
            <div class="center">
              <p>作者：{{ list.author }}</p>
              <p>{{ list.createTime }}</p>
              <div class="s1">
                <img
                  style="width: 0.75rem; height: 0.75rem; margin-top: 0.3125rem"
                  src="../../assets/er.png"
                  alt=""
                />
                <p>{{ list.pageview }}人聆听</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shuji">
        <div class="shushu">
          <div class="shu"></div>
          <p>书籍介绍：</p>
        </div>
        <div class="js" style="padding: 0.625rem;">
          <p id="contentRef" v-html="list.contentByP" ref="contentRef"></p>
        </div>
        <div class="shushu">
          <div class="shu"></div>
          <p>朗读者介绍：</p>
        </div>

        <div class="js">
          <p>{{ readerStr }}</p>
        </div>
      </div>
    </div>

    <div class="di">
      <div class="di-one">
        <marquee scrollamount="3">
          {{ list.title }}
        </marquee>
      </div>
      <div class="bf">
        <img @click="prevAudio" src="../../assets/last.png" alt="" />
        <img v-if="a" @click="qiehuan" src="../../assets/stop.png" alt="" />
        <img
          v-else
          @click="qiehuan"
          src="../../assets/start.png"
          alt=""
        />
        <img @click="nextAudio" src="../../assets/next.png" alt="" />
      </div>
      <div class="jbt">
        <p>{{ currentTime }}</p>
        <van-slider v-model="audioValue" active-color="#007AFF" button-size="18px" @change="audioChange" />
        <p>{{ duration }}</p>
      </div>
    </div>
    <audio class="audio_content" :src="audioUrl" ref="audioContent" />
  </div>
</template>

<script>
import { Toast } from "vant"
import axios from "axios";
export default {
  data() {
    return {
      a: false,
      id: "",
      list: [],
      audioUrl: null,
      audioValue: 0,
      duration: '00:00',
      currentTime: '00:00',
      audioList: [],
      currentIndex: null,
      changeType: false,
      readerStr: null
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getdata(this.id);
    if (window.localStorage.getItem('audioList')) {
      this.audioList = JSON.parse(window.localStorage.getItem('audioList'))
      this.audioList.map((item, index) => {
        if (Number(item.id) === Number(this.id)) this.currentIndex = index
      })
    }
  },

  mounted() {
    const audioBox = this.$refs.audioContent
    audioBox.ondurationchange = () => {
      this.duration = this.timeFormat(audioBox.duration)
    }

    audioBox.ontimeupdate = () => {
      this.currentTime = this.timeFormat(audioBox.currentTime)
      this.audioValue = (audioBox.currentTime / audioBox.duration) * 100
    }

    audioBox.onended = () => {
      this.currentTime = '00:00'
      this.a = false
      this.audioValue = 0
    }
  },
  methods: {
    //将单位为秒的的时间转换成mm:ss的形式
    timeFormat(number) {
      let minute = parseInt(number / 60)
      let second = parseInt(number % 60)
      minute = minute >= 10 ? minute : "0" + minute
      second = second >= 10 ? second : "0" + second
      return minute + ":" + second
    },
    getdata(id) {
      axios({
        url: `/api/system/articles/${id}`,
        method: "get",
      }).then((res) => {
        this.list = res.data.data
        this.readerStr = res.data.data.contentByP.match(/朗读者介绍：(\S*)。</)[1]
        this.audioUrl = res.data.data.iframeSrc
        this.changeType = false
      });
    },

    qiehuan() {
      this.a = !this.a;
      !this.a ? this.$refs.audioContent.pause() : this.$refs.audioContent.play()
    },
    gohomes() {
      this.$router.go(-1);
    },

    audioChange(value) {
      this.currentTime = this.timeFormat(this.$refs.audioContent.duration * (value / 100))
      this.$refs.audioContent.currentTime = this.$refs.audioContent.duration * (value / 100)
    },
    // 上一个
    prevAudio() {
      if (this.currentIndex === 0) {
        Toast.fail('已经是第一个了')
        return false
      }

      if (this.changeType) {
        Toast.fail('加载中,请稍后...')
        return false
      }

      this.currentIndex = this.currentIndex - 1
      this.resetAudio()
    },
    // 下一个
    nextAudio() {
      if (this.currentIndex === this.audioList.length) {
        Toast.fail('已经是列表最后一个了')
        return false
      }

      if (this.changeType) {
        Toast.fail('加载中,请稍后...')
        return false
      }

      this.currentIndex = this.currentIndex + 1
      this.resetAudio()
    },
    // 重置播放器数据
    resetAudio() {
      this.changeType = true
      this.a = false
      this.audioValue = 0
      this.audioUrl = null
      this.currentTime = '00:00'
      this.$refs.audioContent.pause()
      this.$refs.audioContent.currentTime = 0
      this.$router.replace(`/soul?id=${this.audioList[this.currentIndex].id}`)
      this.getdata(this.audioList[this.currentIndex].id)
    }
  },
};
</script>

<style lang="scss" scoped>
.soul-index {
  background: #f7f7f7;
  min-height: 100vh;

  .audio_content {
    position: absolute;
    top: 99999px;
    opacity: 0;
  }
  .di {
    width: 100%;
    position: fixed;
    bottom: 0;
    background: #fff;
    box-shadow: 0rem -0.125rem 0.625rem 0rem rgba(9, 25, 50, 0.1);
    padding: 1rem 0;
    .jbt {
      width: 100%;
      height: 2.5rem;
      justify-content: space-around;
      display: flex;
      align-items: center;
      p {
        color: #999999;
        font-size: 0.75rem;
      }
      div {
        width: 16.75rem;
        height: 0.375rem;
        background: #eaeaea;
        border-radius: 0.9375rem 0.9375rem 0.9375rem 0.9375rem;
        opacity: 1;
      }
    }
    .bf {
      width: 100%;
      height: 3.5rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
      img:first-child {
        width: 1.875rem;
        height: 1.625rem;
      }
      img:last-child {
        width: 1.875rem;
        height: 1.625rem;
      }
      img:nth-child(2) {
        width: 3.25rem;
        height: 3.125rem;
      }
    }
    .di-one {
      width: 23.4375rem;
      background: #fff;

      marquee {
        margin: auto;
        max-width: 18.5rem;
        overflow: hidden;
        font-size: 0.875rem;
        font-family: PingFang SC-粗体, PingFang SC;
        font-weight: normal;
        position: relative;
        left: calc(50% - 9.23rem);
        padding: 0.04rem 0;
      }
    }
  }
  .js {
    width: 21.8125rem;
    height: 180px;
    font-size: 0.875rem;
    font-family: PingFang SC-中等, PingFang SC;
    font-weight: normal;
    color: #777777;
    line-height: 1.25rem;
    margin: auto;
    padding: 0.625rem 0.625rem 6rem;
    overflow: auto;
    overflow-y: scroll;
  }
  .shuji {
    width: 100%;
    height: 25rem;
    background: #f7f7f7;
    .shushu {
      width: 100%;
      height: 1.875rem;
      display: flex;
      align-items: center;
      p {
        color: #333333;
        font-size: 0.875rem;
        margin-left: 0.3125rem;
      }
      .shu {
        margin-left: 0.625rem;
        width: 0.1875rem;
        height: 0.75rem;
        background: #007aff;
        border-radius: 13.25rem 13.25rem 13.25rem 13.25rem;
        opacity: 1;
      }
    }
  }
  .list {
    width: 23.4375rem;
    height: 11rem;
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 1;
    margin: auto;
    display: flex;
    .right {
      width: 65%;
      height: 100%;
      .right-item {
        width: 100%;
        height: 100%;
        .top {
          width: 100%;
          height: 50%;
          color: #323332;
          font-size: 1rem;
          padding: 0.625rem;
          box-sizing: border-box;
          font-weight: bold;
        }
        .center {
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #999999;
          font-size: 0.85rem;
          .s1 {
            display: flex;
            align-items: center;
          }
          p {
            margin-top: 0.3125rem;
          }
          p:first-child {
            margin-top: 0.9375rem;
          }
        }
      }
    }
    .left {
      width: 35%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .left-img {
        width: 90%;
        height: 90%;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .top {
    width: 100%;
    height: 3.125rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .incon {
      margin-left: -2.5rem;
    }
  }
}
</style>